{
  "save": "@:common.actions.save",
  "common": {
    "verify": "@:common.actions.verify",
    "unexpectedError": "Ocurrió un error inesperado. Intenta de nuevo."
  },
  "generalInfo": {
    "tab": "Información general",
    "tabMobile": "General",
    "srText": "Configuración de la cuenta - Información general",
    "name": {
      "label": "@:common.form.labels.name",
      "pageTitle": "Editar nombre",
      "firstName": "@:common.form.labels.firstName",
      "firstNameError": "Ingresa tu nombre.",
      "lastName": "@:common.form.labels.lastName",
      "lastNameError": "Ingresa tu apellido.",
      "cta": "@:accountSettings.save",
      "successToast": "Nombre actualizado."
    },
    "email": {
      "label": "@:common.form.labels.email",
      "pageTitle": "Editar correo electrónico",
      "cta": "@:accountSettings.save",
      "helperText": "Se le enviará un correo electrónico de verificación.",
      "successToast": "Correo electrónico de verificación enviado.",
      "noEmailError": "@:common.textInputErrors.emailRequired",
      "invalidEmailError": "@:common.textInputErrors.invalidEmail",
      "sameEmailError": "La nueva dirección de correo electrónico debe ser diferente de la actual.",
      "unavailableError": "Esta dirección de correo electrónico ya está en uso.",
      "verify": {
        "successTitle": "Verificación de correo electrónico",
        "emailVerified": "Tu correo electrónico se actualizó correctamente a:",
        "emailVerifiedLogin": "Inicia sesión con tu nuevo correo electrónico.",
        "signIn": "Iniciar sesión",
        "errorTitle": "Error de verificación",
        "errorMsg": "No se encontró este enlace de activación. Es posible que esta dirección de correo electrónico ya se haya verificado o activado."
      },
      "modal": {
        "title": "Verifica tu nueva dirección de correo electrónico",
        "lineOne": "Hemos enviado un correo electrónico de verificación a {email}.",
        "lineTwo": "Sigue las instrucciones para confirmar tu nueva dirección de correo electrónico y úsala para iniciar sesión en TalkingParents.",
        "submit": "@:common.actions.okay"
      }
    },
    "timezone": {
      "label": "Zona horaria",
      "secondaryLabel": "Formato de fecha",
      "combinedLabel": "Zona horaria/formato de fecha",
      "pageTitle": "Editar zona horaria/formato de fecha",
      "cta": "@:accountSettings.save",
      "successToast": "Zona horaria/formato de fecha actualizado.",
      "updateError": "No pudimos actualizar tu zona horaria. Inténtalo de nuevo o elige una zona horaria diferente."
    },
    "language": {
      "label": "Idioma",
      "en": "English",
      "es": "Español"
    },
    "phoneNumber": {
      "label": "Número de celular",
      "pageTitle": "Editar número de celular",
      "verified": "Verificado",
      "unverified": "No verificado",
      "empty": "No se proporcionó número de celular",
      "description": "Tu número de celular debe estar verificado para hacer y recibir llamadas telefónicas grabadas. TalkingParents no comparte esta información con el otro progenitor.",
      "hintText": "Le enviaremos un código temporal por mensaje de texto.",
      "removeNumberCta": "@:common.actions.removeInline",
      "cta": "@:common.actions.sendCode",
      "removeModal": {
        "button": "@:common.actions.removeInline",
        "title": "Eliminar número de celular",
        "content": "Eliminar tu número de celular desactivará la autenticación multifactor. ¿Deseas continuar?",
        "modalCta": "Sí, eliminar este número de teléfono",
        "successToast": "Número de celular eliminado."
      },
      "modal": {
        "title": "Verificar número de celular",
        "description": "Ingresa a continuación el código de 6 dígitos que enviamos a {0} para verificar tu número de celular.",
        "cta": "@:accountSettings.common.verify",
        "sendAnotherCode": "@:accountSettings.generalInfo.mfa.modal.sendAnotherCode",
        "resentText": "@:common.mfa.codeSentText",
        "successVerifyToast": "@:common.mfa.phoneVerifiedToast",
        "successUpdateToast": "Número de celular actualizado.",
        "errors": {
          "expiredCode": "Este código venció. Intenta de nuevo con un código nuevo.",
          "incorrectCode": "Código de verificación incorrecto. Revisa tu número de teléfono o intenta enviar otro código en 30 segundos.",
          "tooManyAttempts": "Solo puedes enviar un código cada 30 segundos. Intenta de nuevo en 30 segundos.",
          "unexpected": "Ocurrió un error inesperado. Contacta a soporte para obtener ayuda."
        }
      },
      "errors": {
        "invalid": "Ingresa un número de celular válido.",
        "tooManyAttempts": "Demasiados intentos. Intenta más tarde o contacta a soporte para obtener ayuda."
      }
    },
    "mfa": {
      "label": "@:common.mfa.label",
      "enable": "Activar",
      "description": "Protege tu cuenta con autenticación multifactor basada en mensajes de texto.",
      "modal": {
        "title": "@:common.mfa.enableTitle",
        "description": "Ingresa el código de 6 dígitos que enviamos a {0}",
        "cta": "@:common.actions.verify",
        "sendAnotherCode": "enviar otro código",
        "resentText": "@:common.mfa.codeSentText",
        "helpText": "¿No lo recibió? Visite nuestro {0}",
        "helpCenter": "@:common.links.helpCenter"
      },
      "errors": {
        "alreadyDisabled": "La autenticación multifactor ya está desactivada."
      },
      "enabledToast": "Autenticación multifactor activada.",
      "disabledToast": "Autenticación multifactor desactivada."
    },
    "matchedLabel": "Vinculado",
    "matchedYes": "@:common.actions.yes",
    "matchedNo": "@:common.actions.no",
    "coParentLabel": "Copadre",
    "matchedOnLabel": "Vinculado el",
    "accountCreatedLabel": "Cuenta creada"
  },
  "professionals": {
    "tab": "Profesional Vinculado",
    "tabMobile": "Vinculado"
  },
  "planDetails": {
    "tab": "Detalles del plan",
    "tabMobile": "Plan",
    "label": "Tipo de plan",
    "loadingPlan": "Cargando plan...",
    "subscriptionType": {
      "storeSub": "Suscripción {name}",
      "complimentary": "Cortesía",
      "pfcComplimentary": "Plan de cortesía"
    },
    "upgradePlan": "@:common.actions.upgradePlan",
    "upgradeOnly": "@:common.actions.upgrade",
    "switchPlan": "Cambiar plan",
    "managePlan": "Administrar plan",
    "startFreeTrial": "Iniciar prueba gratuita de 30 días",
    "upgradeToStandard": "Mejorar a Standard",
    "upgradeToPremium": "Mejorar a Premium",
    "upgradeTo": "Mejorar a {planName}",
    "tryForFree": "Pruebe {planName} gratis",
    "getPlanForPrice": "Obtenga el {planName} por {planPrice}/mes. Cancele en cualquier momento.",
    "freeTrialForTier": "Gratis durante 30 días para nuevos suscriptores; luego {planPrice}/mes. Cancele en cualquier momento.",
    "seeComparison": "Ver comparación completa de precios",
    "billingInfoHeader": "Información de facturación",
    "billingTypeLabel": "Tipo de facturación",
    "billingTypes": {
      "monthly": "@:common.plans.billing.monthly",
      "annual": "@:common.plans.billing.annual",
      "feeWaiver": "Exención de tarifas",
      "promo": "Promoción",
      "pfcPromo": "Promoción de 12 meses"
    },
    "billingNextLabel": "Próxima fecha de facturación",
    "currentPlanExpiresLabel": "Vencimiento del plan actual",
    "expirationDateLabel": "Fecha de vencimiento",
    "promotionExpiresLabel": "La promoción vence el",
    "notAvailable": "No disponible",
    "feeWaiverNotice": "Exención de tarifas aplicada. Vuelve a solicitarla antes de esta fecha para que tu acceso no venza. Para volver a solicitarla, contacta a soporte.",
    "promoNotice": "Oferta promocional aplicada. Tu plan se renovará a la tarifa anual estándar.",
    "pfcPromoNotice": "Oferta promocional aplicada. Cuando el plan venza, deberás volver a suscribirte.",
    "promoPurchasedNotice": "Tu plan actual está activo hasta el {expirationDate}. Tu período promocional comenzará automáticamente cuando venza tu plan actual. Después de 12 meses, tu plan se renueva a la tarifa estándar.",
    "cancel": "Fecha de cancelación",
    "successToast": "Plan actualizado.",
    "tiers": {
      "free": "@:common.plans.free",
      "basic": "@:common.plans.essentials",
      "enhanced": "@:common.plans.enhanced",
      "standard": "@:common.plans.standard",
      "ultimate": "@:common.plans.ultimate",
      "premium": "@:common.plans.premium",
      "unknown": "Desconocido",
      "essentials": "@:common.plans.essentials"
    },
    "planName": {
      "free": "@:common.planNames.free",
      "basic": "@:common.planNames.essentials",
      "enhanced": "@:common.planNames.enhanced",
      "standard": "@:common.planNames.standard",
      "ultimate": "@:common.planNames.ultimate",
      "premium": "@:common.planNames.premium",
      "unknown": "Desconocido"
    },
    "multiSubModal": {
      "title": "Múltiples suscripciones activas",
      "subList": "Tiene varias suscripciones activas a través de:",
      "cancelText": "Cancela una de tus suscripciones para evitar cargos duplicados.",
      "tpSub": "Al mantener tu suscripción a través del sitio web de TalkingParents, podemos darte mejor soporte y ayudarte a administrar la facturación."
    },
    "existingSubscriptionModal": {
      "title": "Suscripción activa existente",
      "content": "Tu cuenta ya tiene una suscripción activa en TalkingParents. Contacta a soporte para obtener ayuda.",
      "cta": "@:common.actions.okay"
    },
    "appleSubModal": {
      "title": "Suscripción de Apple",
      "content": "Mejoraste tu cuenta a través de la App Store de Apple. Apple no permite que TalkingParents administre suscripciones ni compras dentro de la aplicación. Visita la App Store de Apple para administrar tu suscripción o contacta al soporte de Apple para obtener más información.",
      "cta": "@:common.actions.okay"
    },
    "androidSubModal": {
      "title": "Suscripción de Google Play",
      "content": "Mejoraste tu cuenta a través de la Google Play Store. Google no permite que TalkingParents administre suscripciones ni compras dentro de la aplicación. Visita la Google Play Store para administrar tu suscripción o contacta al soporte de Google para obtener más información.",
      "cta": "@:common.actions.okay"
    },
    "premiumConfirmModal": {
      "title": "Aproveche al máximo Premium",
      "content": "Para aprovechar al máximo nuestro Plan Premium con Accountable Calling{0}, tanto tú como el otro progenitor deben verificar su número de teléfono y habilitar las llamadas telefónicas o de video en la configuración de la cuenta. Puedes actualizar estas opciones en cualquier momento. Nunca compartiremos tu número de teléfono con el otro progenitor.",
      "cta": "Entiendo, mejorar mi cuenta",
      "cancelCta": "Cancelar"
    },
    "complimentaryPlanModal": {
      "title": "No se puede modificar el plan",
      "content": "Tienes una promoción aplicada a tu cuenta. Para realizar cambios en tu plan, comunícate con soporte.",
      "cta": "@:common.links.contactSupport"
    },
    "promoPurchasedModal": {
      "title": "No se puede modificar el plan",
      "content": "Tienes una promoción aplicada a tu cuenta. Para realizar cambios en tu plan, comunícate con soporte.",
      "cta": "@:common.links.contactSupport"
    },
    "subscriptionMigrationModal": {
      "title": "No puedes administrar el plan",
      "content": "Tienes una suscripción programada para cancelarse debido a la migración de nuestro procesador de pagos y no podrás administrar tu suscripción hasta que se complete la migración.",
      "cta": "@:common.links.contactSupport"
    },
    "card": {
      "perAccount": "Una prueba gratuita de Premium o Standard por cuenta.",
      "currentPlan": "Plan actual",
      "freeTrial": "Prueba gratuita de 30 días",
      "premium": {
        "access": "Acceso al sitio web + aplicación móvil",
        "priceTagline": "por suscripción",
        "bullets": [
          "Todas las funciones de Standard y Gratuito, más:",
          "Realiza llamadas telefónicas y de video grabadas",
          "Envía y recibe pagos",
          "120 minutos de llamadas por mes",
          "Acceso a transcripciones y grabaciones de llamadas"
        ]
      },
      "standard": {
        "access": "@:accountSettings.planDetails.card.premium.access",
        "priceTagline": "@:accountSettings.planDetails.card.premium.priceTagline",
        "bullets": [
          "Todas las funciones gratuitas, más:",
          "Acceso a la aplicación móvil",
          "Cree tarjetas de la Biblioteca de Información",
          "Reciba videollamadas grabadas",
          "Reciba mensajes de voz en video",
          "Acceso ilimitado a registros PDF",
          "Almacena y comparte archivos en la Bóveda"
        ]
      },
      "free": {
        "access": "Solo acceso al sitio web",
        "priceTagline": "Sí, es gratis.",
        "bullets": [
          "Envía y recibe mensajes",
          "Cree eventos de calendario compartido",
          "Reciba pagos",
          "Reciba llamadas telefónicas grabadas",
          "Y más…"
        ]
      }
    },
    "freeRecord": {
      "pdfHeader": "Registro PDF gratuito",
      "printedHeader": "Paquete de registros completo",
      "statusLabel": "Estado",
      "statusAvailable": "Disponible",
      "redeemedOnLabel": "Canjeado el",
      "nextAvailableLabel": "Próximo disponible",
      "statusUnavailable": "No disponible"
    },
    "payForCoparent": {
      "cta": "Pagar el plan del otro progenitor",
      "learnMore": "Más información",
      "helpCenter": "@:accountSettings.planDetails.payForCoparent.learnMore",
      "openRedeemModalCta": "El otro progenitor pagó mi plan",
      "pendingEntitlementNotice": "Tu plan actual está activo hasta el {expirationDate}. Tu período promocional comenzará automáticamente cuando venza tu plan actual. Después de 12 meses, deberás volver a suscribirte.",
      "expiresLabel": "Vence",
      "grantedEntitlementNotice": "Tu plan promocional está activo hasta {expirationDate}. Después de 12 meses, tendrás que volver a suscribirte.",
      "redeemSuccessToast": "Plan actualizado correctamente",
      "reviewModal": {
        "title": "Revisa el acceso del otro progenitor",
        "intro": "Confirma los siguientes datos antes de continuar con el pago.",
        "planValue": "{price} por 12 meses",
        "content": "Después del pago, le enviaremos un correo electrónico a {coParentName} con instrucciones para activar su acceso. Tendrá {offerExpirationDays} días para canjear su plan. Tu plan de TalkingParents no cambiará.",
        "cancelCta": "@:common.actions.cancel",
        "continueCta": "Continuar al pago"
      },
      "redeemModal": {
        "title": "El otro progenitor pagó un año de acceso al plan {tier}.",
        "titleMobile": "El otro progenitor pagó tu plan.",
        "intro": "Para tu cuenta vinculada con {coParentName}.",
        "availableAccess": "Acceso disponible",
        "monthsIncluded": "meses incluidos",
        "content": "No se requiere tarjeta de crédito ni pago. Canjea antes del {expirationDate}. El plan incluye 12 meses de acceso al plan {tier}. Para hacer cambios en este plan, debes contactar a soporte. Al terminar los 12 meses, esta suscripción finalizará y deberás suscribirte a un plan nuevo.",
        "learnMore": "@:accountSettings.planDetails.payForCoparent.learnMore",
        "redeemCta": "Canjear plan"
      },
      "confirmModal": {
        "title": "Confirma tu nuevo plan",
        "content": "Estás a punto de comenzar 12 meses del plan {tier}, pagados por el otro progenitor. No podrás hacer cambios en tu suscripción una vez que esté activa.",
        "scheduledContent": "No podrás hacer cambios en tu plan una vez que esté activo. Visita nuestro Centro de ayuda para obtener más información sobre cómo canjear un plan pagado por el otro progenitor.",
        "goBack": "Volver",
        "confirmCta": "Confirmar plan",
        "learnMore": "@:accountSettings.planDetails.payForCoparent.learnMore",
        "contactSupport": "Contactar a soporte"
      },
      "activePlanModal": {
        "title": "Ya tienes un plan activo",
        "intro": "Puedes canjear este plan una vez que canceles tu plan actual.",
        "content": "Tu nuevo plan se activará cuando venza tu plan anterior. Si tienes otro plan promocional o de cortesía y quieres hacer cambios en tu suscripción, deberás contactar a soporte. Si te suscribiste a través de otra tienda de aplicaciones, como Apple o Google Play, deberás cancelar desde esa tienda.",
        "managePlan": "Administrar plan",
        "learnMore": "@:accountSettings.planDetails.payForCoparent.learnMore",
        "contactSupport": "Contactar a soporte"
      },
      "success": {
        "title": "Compra exitosa",
        "content": "Gracias por tu compra. El otro progenitor recibirá un correo electrónico con instrucciones para activar su suscripción.",
        "cta": "@:common.actions.done"
      },
      "error": {
        "content": "Hay un problema con tu patrocinio. Contacta a soporte.",
        "entitlementTimeoutContent": "La actualización de tu plan está tardando más de lo esperado. Vuelve a revisar en unos minutos. Si tu plan aún no se ha actualizado, contacta a soporte."
      }
    },
    "paywall": {
      "header": "Administrar plan",
      "fullPricePlans": "Planes a precio regular",
      "promoBanner": "{important}: Tienes una promoción aplicada a tu cuenta. Para realizar cambios en tu plan, {contactSupport}.",
      "promoBannerImportant": "Importante",
      "promoBannerContactSupport": "@:common.links.contactSupport",
      "tableHeader": {
        "monthly": "@:common.plans.billing.monthly",
        "annual": "@:common.plans.billing.annual",
        "save": "(Ahorra 8 %)"
      },
      "free": {
        "header": "@:common.plans.free",
        "subHeader": "",
        "webOnly": "Solo web",
        "bullets": [
          "Mensajería segura con anuncios",
          "Calendario Compartido",
          "Diario Personal",
          "Reciba llamadas telefónicas grabadas",
          "Con anuncios",
          "Acceso básico a la mayoría de las funciones",
          "Requiere compras dentro de la aplicación"
        ],
        "monthlyPrice": "0",
        "annualPrice": "0",
        "savingsMonthly": "",
        "savingsAnnual": ""
      },
      "currency": "$",
      "usd": "USD",
      "perMonth": "por mes",
      "perYear": "por año",
      "upgradePlan": "@:common.actions.upgradePlan",
      "currentPlan": "Plan actual",
      "managePlan": "Administrar plan",
      "essentials": {
        "header": "@:common.plans.essentials",
        "subHeader": "Mensajería, Calendario, y además:",
        "bullets": [
          "{minutes} minutos de llamadas",
          "1 GB de almacenamiento en la Bóveda"
        ],
        "monthlyPrice": "6",
        "annualPrice": "60",
        "savingsMonthly": "Ahorre {currency}7 con planes anuales",
        "savingsAnnual": "Ahorra {currency}7 al año."
      },
      "enhanced": {
        "header": "@:common.plans.enhanced",
        "subHeader": "Todo lo de Essentials, y además:",
        "bullets": [
          "{minutes} minutos de llamadas",
          "Registros PDF ilimitados",
          "15 GB de almacenamiento en la Bóveda"
        ],
        "monthlyPrice": "12",
        "annualPrice": "120",
        "savingsMonthly": "Ahorre {currency}16 con planes anuales",
        "savingsAnnual": "Ahorra {currency}16 al año."
      },
      "ultimate": {
        "header": "@:common.plans.ultimate",
        "subHeader": "Todo lo de Enhanced, y además:",
        "bullets": [
          "Minutos de llamadas ilimitados",
          "Sentiment Scanner + Writing Assist℠ (herramientas de IA)",
          "Soporte prioritario",
          "Pago exprés",
          "50 GB de almacenamiento en la Bóveda"
        ],
        "monthlyPrice": "27",
        "annualPrice": "270",
        "savingsMonthly": "Ahorre {currency}32 con planes anuales",
        "savingsAnnual": "Ahorra {currency}32 al año."
      },
      "seeFullPricingPlan": "¿Necesita ayuda para decidir? Vea el {pricingPlan} completo para más opciones.",
      "pricingPlan": "plan de precios",
      "promo": {
        "titlePrice1": "[Promo Card Title If The Title Is Long ]",
        "bullet1Price1": "Acceso completo al plan {tier}",
        "bullet2Price1": "12 meses facturados {upfront}",
        "bullet2UpfrontPrice1": "por adelantado",
        "bullet3Price1": "Sin interrupción en {yourAccount}",
        "bullet3YourAccountPrice1": "tu cuenta",
        "titlePrice2": "[Second promo]",
        "bullet1Price2": "[Foo]",
        "bullet2Price2": "[Bar]",
        "bullet3Price2": "[Baz]",
        "cta": "Obtener oferta de 12 meses",
        "disclaimer": "Se renueva al precio estándar después del período promocional"
      },
      "discountedOfferTitle": "Oferta con descuento",
      "limitedTimeOfferLabel": "Oferta por tiempo limitado",
      "limitedTimeOfferDetailFree": "Oferta disponible solo hasta el 1 de junio de 2026, pagada por adelantado. Se factura como un cargo único de 12 meses. Después de 12 meses, tu plan se renueva a la tarifa anual estándar.",
      "limitedTimeOfferDetailPaid": "Oferta disponible solo hasta el 1 de junio de 2026, pagada por adelantado. El período promocional comienza después de que expire tu plan actual. Se factura como un cargo único de 12 meses. Después de 12 meses, tu plan se renueva a la tarifa anual estándar.",
      "fullPricePlansLabel": "Planes a precio regular",
      "promoCard": {
        "cta": "Asegurar mi oferta",
        "planOnly": "Plan {planName}",
        "planForPrice": "Plan {planName} por {price}",
        "discountAvailable": "Descuento disponible para el plan {planName}",
        "discounts": {
          "price1": {
            "essentials": "16 % de descuento en el precio mensual de Essentials / 9 % de descuento en el precio anual de Essentials",
            "enhanced": "16 % de descuento en el precio mensual de Enhanced / 9 % de descuento en el precio anual de Enhanced",
            "ultimate": "16 % de descuento en el precio mensual de Ultimate / 9 % de descuento en el precio anual de Ultimate"
          },
          "price2": {
            "essentials": "14 % de descuento en el precio mensual de Essentials / 6 % de descuento en el precio anual de Essentials",
            "enhanced": "25 % de descuento en el precio mensual de Enhanced / 18 % de descuento en el precio anual de Enhanced",
            "ultimate": "15 % de descuento en el precio mensual de Ultimate / 7 % de descuento en el precio anual de Ultimate"
          }
        }
      }
    },
    "duplicateSubscriptionModal": {
      "title": "Suscripción activa existente",
      "content": "Tu cuenta ya tiene una suscripción activa en TalkingParents. Contacta a soporte para obtener ayuda."
    },
    "promotionExpiresOnLabel": "La promoción vence el",
    "newPlanStartsLabel": "Inicio del nuevo plan",
    "promoPurchasedExplanation": "Tu plan actual está activo hasta el {date}. Tu período promocional comenzará automáticamente cuando venza tu plan actual. Después de 12 meses, tu plan se renueva a la tarifa estándar."
  },
  "calling": {
    "tab": "Accountable Calling",
    "tabMobile": "Llamadas"
  },
  "notifications": {
    "tab": "Notificaciones",
    "email": {
      "label": "Notificaciones por correo electrónico",
      "description": "Recibe un correo electrónico cuando llegue un nuevo mensaje, evento de calendario o tarjeta de la Biblioteca de Información.",
      "disabledSuccessToast": "Notificaciones por correo electrónico desactivadas.",
      "enabledSuccessToast": "Notificaciones por correo electrónico activadas."
    },
    "text": {
      "label": "Notificaciones por mensaje de texto",
      "description": "Reciba notificaciones de nuevos mensajes por mensaje de texto.",
      "remainingBalance": "Saldo restante",
      "disabledSuccessToast": "Notificaciones por mensaje de texto desactivadas.",
      "enabledSuccessToast": "Notificaciones por mensaje de texto activadas.",
      "disableModal": {
        "title": "Desactivar notificaciones por mensaje de texto",
        "content": "Confirme que desea desactivar las notificaciones por mensaje de texto y reembolsar el saldo prepagado restante.",
        "confirmCta": "@:common.actions.okay",
        "cancelCta": "@:common.actions.cancel"
      },
      "unverifiedModal": {
        "title": "Número no verificado",
        "content": "Verifica tu número de celular antes de activar las notificaciones por mensaje de texto.",
        "confirmCta": "@:common.actions.okay"
      },
      "enterVerificationCode": "Ingresa el código de verificación",
      "enableTitle": "Activar notificaciones por mensaje de texto",
      "checkoutRedirectError": "Hubo un error al redirigirte a la página de pago. Intenta de nuevo."
    },
    "newsletter": {
      "label": "Boletines por correo electrónico",
      "description": "Manténgase informado con las últimas actualizaciones y recursos para la crianza.",
      "cta": "Editar preferencias"
    }
  },
  "password": {
    "tab": "@:common.form.labels.password",
    "srText": "Configuración de la cuenta - Actualizar contraseña",
    "current": {
      "label": "Contraseña actual",
      "emptyError": "Se requiere la contraseña actual.",
      "incorrectError": "La contraseña actual es incorrecta."
    },
    "new": {
      "label": "@:common.form.labels.newPassword",
      "emptyError": "Se requiere una nueva contraseña.",
      "requirementsError": "La contraseña no cumple los requisitos.",
      "sameError": "La nueva contraseña no puede coincidir con la actual."
    },
    "confirm": {
      "label": "Confirmar nueva contraseña",
      "emptyError": "Confirma la nueva contraseña.",
      "noMatchError": "@:common.form.passwordMismatch"
    },
    "successToast": "Contraseña actualizada.",
    "update": "Actualizar"
  },
  "links": {
    "tos": "Términos de servicio",
    "privacyPolicy": "@:common.links.privacyPolicy"
  },
  "messaging": {
    "tab": "Mensajería Segura",
    "tabMobile": "Mensajería",
    "toggle": {
      "label": "Sugerir eventos de calendario",
      "description": "Crea automáticamente eventos a partir de tus mensajes para que los revises y agregues a tu Calendario Compartido."
    },
    "sentimentToggle": {
      "label": "Mostrar sentimiento (Privado)",
      "description": "Muestra tu Puntuación de Sentimiento en los mensajes analizados de la conversación. Solo tú puedes verla y no aparecerá en el registro."
    },
    "paymentRequestToggle": {
      "label": "Sugerir solicitudes de pago",
      "description": "Permita que la IA detecte y sugiera solicitudes de Accountable Payments a partir de tus mensajes.",
      "enabled": "Solicitudes de pago sugeridas activadas.",
      "disabled": "Solicitudes de pago sugeridas desactivadas."
    },
    "errors": {
      "updatePaymentRequestSuggestions": "No se pudo actualizar la configuración de sugerencias de solicitudes de pago.",
      "updateSentiment": "Ocurrió un error inesperado. Intenta de nuevo."
    }
  },
  "calendar": {
    "tab": "Calendario Compartido",
    "tabMobile": "Calendario",
    "header": "Conectar al calendario personal",
    "learnMore": "@:common.links.learnMore",
    "description": "Agrega automáticamente los eventos del Calendario Compartido a tu calendario personal. Solo se agregan los eventos que hayas abierto. Los cambios que hagas a estos eventos en tu calendario personal no se reflejarán en TalkingParents.",
    "provider": {
      "connectCta": "Conectar",
      "disconnected": "Calendario desconectado. Haga clic para reconectar.",
      "deleted": "@:accountSettings.calendar.provider.disconnected",
      "updated": "Última actualización {datetime}",
      "toast": {
        "connected": "{providerName} conectado.",
        "successTitle": "Conexión exitosa"
      },
      "modal": {
        "connect": {
          "header": "\"TalkingParents\" quiere usar \"{providerName}\" para iniciar sesión",
          "content": "TalkingParents necesita permiso para agregar eventos del Calendario Compartido a tu calendario personal.",
          "confirmCta": "@:common.actions.continue",
          "cancelCta": "@:common.actions.cancel"
        },
        "trash": {
          "header": "¿Eliminar calendario conectado?",
          "content": "Esto eliminará el acceso a tu calendario personal y los nuevos eventos del Calendario Compartido ya no se agregarán.",
          "confirmCta": "@:common.actions.continue",
          "cancelCta": "@:common.actions.cancel"
        },
        "scopes": {
          "header": "Permisos requeridos",
          "content": "Para conectar tu calendario con TalkingParents, debes otorgar todos los permisos solicitados. Intenta conectar de nuevo y acepta ambas solicitudes de permisos. Visita el Centro de ayuda para obtener más información.",
          "confirmCta": "Intentar de nuevo",
          "cancelCta": "@:common.actions.cancel"
        },
        "disconnected": {
          "header": "Calendario desconectado",
          "content": "TalkingParents ya no está conectado a tu calendario personal. Los nuevos eventos no se agregarán hasta que lo vuelvas a conectar.",
          "confirmCta": "Reconectar",
          "cancelCta": "@:common.actions.notNow"
        },
        "deleted": {
          "header": "Calendario desconectado",
          "content": "TalkingParents se desconectó de tu calendario personal. Visita el Centro de ayuda para ver soluciones comunes y pasos de resolución de problemas.",
          "confirmCta": "@:common.links.helpCenter",
          "cancelCta": "@:common.actions.notNow"
        },
        "connectIssue": {
          "header": "Problema de conexión del calendario",
          "content": "TalkingParents no puede conectarse a tu calendario personal. Visita el Centro de ayuda para ver soluciones comunes y pasos de resolución de problemas.",
          "confirmCta": "@:common.links.helpCenter",
          "cancelCta": "Descartar"
        }
      },
      "errors": {
        "initializeGoogleAuth": "No se pudo iniciar la autenticación con Google.",
        "connectGoogle": "TalkingParents no pudo conectarse con Google.",
        "manualSync": "No se pudo sincronizar el calendario manualmente.",
        "disconnect": "No se pudo desconectar el calendario."
      }
    }
  },
  "appearance": {
    "tab": "Apariencia",
    "srText": "Apariencia"
  },
  "minutesPlan": {
    "minutes": "Minutos",
    "selected": "Seleccionado",
    "select": "@:form.select"
  }
}
